<template>
  
  <span>
    <i v-if="disabled" class="ban grey icon"></i>
    <i v-if="!disabled && checked" class="check circle blue icon"></i>
    <i v-if="!disabled && !checked" class="blue circle outline icon"></i>
  </span>

</template>

<script>
  export default {
    props: ["checked", "disabled"], 
  }
</script>

